export interface GetKeysResponse {
  apikeys: string[];
}

export interface CreateKeyResponse {
  key: string;
}

// Must match MAX_API_KEYS in rn-apikey-admin's create-key handler.
export const MAX_API_KEYS = 20;

// rn-apikey-admin identifies a key by its first characters, which are unique
// within a client, so deletes never put the full key in the URL.
export const KEY_PREFIX_LENGTH = 4;

export const getKeyPrefix = (key: string): string =>
  key.slice(0, KEY_PREFIX_LENGTH);
